export const NEXT_QUESTION_KEYS = ['enter']